<template>
    <div style="position: relative;">
        <Header></Header>
        <b-sidebar id="sidebar-1" width="100vw" right shadow>
            <div class="px-3 py-2 text-center">
                <b-img :src="require('@/assets/logo-h.png')" fluid></b-img>
                <b-nav vertical>
                    <b-nav-item @click="_go(i2.url)" v-for="(i2, i1) in links.data" :key="i1">{{ i2.text }}</b-nav-item>
                    <b-nav-item>最新消息</b-nav-item>
                    <b-nav-item>關於我們</b-nav-item>
                    <b-nav-item>聯絡我們</b-nav-item>
                </b-nav>
            </div>
        </b-sidebar>
        <router-view />
        <FloatingBtn></FloatingBtn>
        <CampFloatingBtn></CampFloatingBtn>
        <Footer></Footer>
        <b-modal id="modal-privacy" title="個資保護政策">
            <div v-html="Privacy"></div>
            <template #modal-footer="{ cancel }">
                <b-button size="sm" variant="danger" @click="cancel()">
                    關閉
                </b-button>
            </template>
        </b-modal>
    </div>
</template>

<script>
    // @ is an alias to /src
    import Header from '@/components/Header.vue';
    import Footer from '@/components/Footer.vue';
    import FloatingBtn from './components/FloatingBtn.vue';
    import CampFloatingBtn from './components/CampFloatingBtn.vue';
    import { apiGetInformation } from '@/api/API.js';
    export default {
        name: 'Home',
        components: {
            Header,
            Footer,
            FloatingBtn,
            CampFloatingBtn,
        },
        data() {
            return {
                Privacy: '',
                links: {
                    title: '連結',
                    img: require('@/assets/logo-h.png'),
                    data: {
                        home: { text: '首頁', url: '/' },
                        s1: { text: '課程探索', url: '/courses' },
                        s2: { text: '營隊', url: '/camps' },
                        s3: { text: '最新消息', url: '/news' },
                    },
                },
            };
        },
        mounted() {
            this.$store.dispatch('loadCourseAskUrl');
            this.$store.dispatch('loadCampLineUrl');
        },
        created() {
            apiGetInformation('privacy')
                .then((res) => {
                    this.Privacy = res.data.Content;
                })
                .catch((err) => {
                    console.log(err);
                    //alert(err.respone.data);
                });
        },
    };
</script>
<style>
    * {
        font-family: 'Microsoft JhengHei', '微軟正黑體', 'PingFang TC', '蘋方-繁', 'Heiti TC', '黑體', sans-serif !important;
    }
</style>
